<template>
    
<app-modal :prompt="true" v-on:close="$emit('close')" :title="page.business_profile_people_delete_title" :description="page.business_profile_people_delete_description">

    <template v-slot:foot>

		<app-button theme="red" :text="page.business_profile_people_delete_button_save" :loading="is.loading" v-on:click="onDeleteClick" />
		<app-button theme="plain" :text="page.business_profile_people_delete_button_cancel" :disabled="is.loading" v-on:click="$emit('close')" />

    </template>

</app-modal>

</template>

<script>

import mixinModal from '@/mixin/modal.js'

export default {

    mixins: [mixinModal],
    
	data: function() {

		return {
			is: {
                loading: false
            }
		}

	},

	methods: {
        
		onDeleteClick: function() {

            this.is.loading = true

			this.$api.request('account/profile/people/delete', {
                id: this.params.id
            }).then(function() {

                this.processEvents()
            
                this.$emit('close')

            }.bind(this))

		}

	}
    
}

</script>